import { render, staticRenderFns } from "./MyAttention.vue?vue&type=template&id=12e11977&scoped=true&"
import script from "./MyAttention.vue?vue&type=script&lang=js&"
export * from "./MyAttention.vue?vue&type=script&lang=js&"
import style0 from "./MyAttention.vue?vue&type=style&index=0&id=12e11977&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e11977",
  null
  
)

export default component.exports